export default "__VITE_ASSET__BVlelv82__"